import Repository from './Repository'

const action = 'contragent-groups'

export default {
  add(data) {
    return Repository.post(action, data)
  },
  getList() {
    return Repository.get(action)
  },
  put(id, data) {
    return Repository.put(`${action}/${id}`, data)
  },
  delete(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
